// app/frontend/utils/gclid.js

function getParam(p) {
  const match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

function getExpiryRecord(value) {
  const expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 days in ms
  const expiryDate = new Date().getTime() + expiryPeriod;
  return { value: value, expiryDate: expiryDate };
}

function addGclid() {
  const gclidParam = getParam("gclid");
  const gclidFormFields = ["gclid_field"]; // list all your hidden field IDs
  let gclidRecord = null;
  let currGclidFormField = null;

  const gclsrcParam = getParam("gclsrc");
  const isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf("aw") !== -1;

  gclidFormFields.forEach(function (field) {
    if (document.getElementById(field)) {
      currGclidFormField = document.getElementById(field);
    }
  });

  if (gclidParam && isGclsrcValid) {
    gclidRecord = getExpiryRecord(gclidParam);
    localStorage.setItem("gclid", JSON.stringify(gclidRecord));
  }

  const storedGclid = gclidRecord || JSON.parse(localStorage.getItem("gclid"));
  const isGclidValid = storedGclid && new Date().getTime() < storedGclid.expiryDate;

  if (currGclidFormField && isGclidValid) {
    currGclidFormField.value = storedGclid.value;
  }
}

export { addGclid };
